import { DataLevel, DynamicTurnout, Result } from '@/lib/model';

export const getTournoutValue = (
  dataLevel: DataLevel,
  dynamicTurnout: DynamicTurnout[],
  lastResult: Result
) => {
  const found = dynamicTurnout.find(d => {
    if (dataLevel === DataLevel.MAIN) {
      return d.int.l_terr === 'ITALIA';
    }

    // console.log(
    //     '______',
    //     dataLevel === DataLevel.COMUNE,
    //     lastResult?.idCodes?.codCom
    // );

    if (
      dataLevel === DataLevel.REGIONE ||
      lastResult?.idCodes?.codProv === 'undefined'
    ) {
      return d.int.l_terr == 'REGIONE';
    }

    if (dataLevel === DataLevel.PROVINCIA) {
      return (
        d.int.l_terr === 'PROVINCIA' &&
        // Deve essere == perche non deve fare il cast
        d.enti?.ente_p?.cod == lastResult?.idCodes?.codProv
      );
    }

    if (
      dataLevel === DataLevel.COMUNE ||
      // Deve essere == perche non deve fare il cast
      lastResult?.idCodes?.codCom === 'undefined'
    ) {
      return (
        d.int.l_terr === 'PROVINCIA' &&
        d.enti?.ente_p?.cod == lastResult?.idCodes?.codProv
      );
    }

    if (
      dataLevel === DataLevel.COMUNE &&
      lastResult?.idCodes?.codCom !== 'undefined'
    ) {
      // console.log('lastResult?.idCodes?.codCom', lastResult?.idCodes?.codCom);
      return (
        d.int.l_terr === 'PROVINCIA' &&
        d.enti?.ente_p?.cod == lastResult?.idCodes?.codProv &&
        d.enti?.enti_f?.findIndex(el => el.cod == lastResult?.idCodes?.codCom) >
          -1
      );
    }
  });

  let comVot: any;
  let comunicazioneAttiva: any;

  if (
    dataLevel === DataLevel.COMUNE &&
    lastResult?.idCodes?.codCom !== 'undefined'
  ) {
    let comune = found?.enti?.enti_f?.find(
      el => el.cod == lastResult?.idCodes?.codCom
    );
    comVot = comune?.com_vot || [];
  } else {
    comVot = found?.enti?.ente_p?.com_vot || [];
  }

  comunicazioneAttiva = found?.enti?.ente_p?.com[0].com_att || 0;

  // Se il valore di enti_p della comunicazione corrente e' 0 allora cerco di prendere il valore della comunicazione precedente
  // Se il valore di enti_p della comunicazione corrente e' 0 ed e' la prima comunicazione allora prendo il valore della comunicazione corrente

  let value = comVot[comunicazioneAttiva - 1];

  if (value?.enti_p === 0 && comunicazioneAttiva > 1) {
    value = comVot[comunicazioneAttiva - 2];
  }

  return value;
};
